(() => {
 const init = (root = document) => {
  root.querySelectorAll('[data-v22-rail]').forEach(rail => {
   if(rail.dataset.bound) return;
   rail.dataset.bound='true';
   const section=rail.closest('.a-products');
   if(!section) return;
   const previous=section.querySelector('[data-v22-scroll="prev"]');
   const next=section.querySelector('[data-v22-scroll="next"]');
   const controls=section.querySelector('.a-slider-arrows');
   if(!previous || !next) return;
   const maximum=()=>Math.max(0,rail.scrollWidth-rail.clientWidth);
   const sync=()=>{const max=maximum();previous.disabled=rail.scrollLeft<=2;next.disabled=rail.scrollLeft>=max-2;if(controls) controls.hidden=max<=2;};
   const move=(direction)=>{const card=rail.querySelector('.a-product-card');const gap=parseFloat(getComputedStyle(rail).columnGap)||0;const step=card?card.getBoundingClientRect().width+gap:rail.clientWidth;rail.scrollTo({left:Math.max(0,Math.min(maximum(),rail.scrollLeft+direction*step)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
   previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
   rail.addEventListener('scroll',sync,{passive:true});
   rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}else if(event.key==='Home'||event.key==='End'){event.preventDefault();rail.scrollTo({left:event.key==='Home'?0:maximum(),behavior:'auto'});}});
   if(typeof ResizeObserver!=='undefined'){const observer=new ResizeObserver(sync);observer.observe(rail);}
   addEventListener('resize',sync,{passive:true});sync();
  });
 };
 init();document.addEventListener('shopify:section:load',event=>init(event.target));
 const header=document.querySelector('.a-overlay-header');
 if(header){const update=()=>header.classList.toggle('is-scrolled',scrollY>38);addEventListener('scroll',update,{passive:true});update();}
 document.querySelectorAll('#V22Menu a').forEach(link=>link.addEventListener('click',()=>document.querySelector('#V22Menu [data-po-drawer-close]')?.click()));
})();
